import React from "react";
import { Row, Col, Button, Card, Input } from "antd";
import Select from "react-select";

const FormLayout = ({
  sourceCode,
  setSourceCode,
  AlllistOptions,
  selectedList,
  setSelectedList,
  segmentAllOptions,
  selectedSegment,
  setSelectedSegment,
  priority,
  setPriority,
  testContOptions,
  selectTestCont,
  setSelectTestCont,
  shipQty,
  setShipQty,
  mailQty,
  setMailQty,
  maxAllOptions,
  selectMaxAll,
  setSelectMaxAll,
  comment,
  setComment,
  productCategory,
  cost,
  setCost,
  handleSaveList,
  setIsListDrawerOpen,
  setEditListId,
  pendingSegmentName,
}) => {
  const menuPortal = (base) => ({ ...base, zIndex: 9999 });

  return (
    <Card
      style={{ marginBottom: 16, background: "#f7f7f7" }}
      bodyStyle={{ padding: 16 }}
    >
      <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
        <Row
          gutter={8}
          align="bottom"
          nowrap
          style={{ flexWrap: "nowrap", minWidth: "1200px", padding: "16px" }}
        >
          <Col style={{ minWidth: "120px" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label>Source Code</label>
              <Input
                value={sourceCode}
                onChange={(e) => setSourceCode(e.target.value)}
                placeholder="Source Code"
              />
            </div>
          </Col>
          <Col style={{ minWidth: "200px" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <label>Select List</label>
                <Button
                  type="link"
                  style={{
                    alignSelf: "flex-start",
                    padding: 0,
                    marginBottom: 2,
                  }}
                  onClick={() => {
                    setEditListId(null);
                    setIsListDrawerOpen(true);
                  }}
                >
                  + Add New
                </Button>
              </div>

              <Select
                options={AlllistOptions}
                value={selectedList}
                onChange={(value) => {
                  setSelectedList(value);
                  // Only clear selected segment if there isn't a pending segment to set
                  if (!pendingSegmentName) {
                    setSelectedSegment(null);
                  }
                }}
                placeholder="Select List"
                menuPortalTarget={
                  typeof window !== "undefined" ? document.body : null
                }
                menuPosition="fixed"
                styles={{
                  menuPortal,
                }}
              />
            </div>
          </Col>
          <Col style={{ minWidth: "200px" }}>
            <label>Select Segment</label>
            <Select
              options={segmentAllOptions}
              value={selectedSegment}
              onChange={setSelectedSegment}
              placeholder="Select Segment"
              isDisabled={!selectedList}
              menuPortalTarget={
                typeof window !== "undefined" ? document.body : null
              }
              menuPosition="fixed"
              styles={{
                menuPortal,
              }}
            />
          </Col>
          <Col style={{ minWidth: "100px" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label>Priority</label>
              <Input
                value={priority}
                onChange={(e) => setPriority(e.target.value)}
                placeholder="Priority"
              />
            </div>
          </Col>
          <Col style={{ minWidth: "120px" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label>Test/Cont.</label>
              <Select
                options={testContOptions}
                value={selectTestCont}
                onChange={setSelectTestCont}
                placeholder="Test/Cont."
                menuPortalTarget={
                  typeof window !== "undefined" ? document.body : null
                }
                menuPosition="fixed"
                styles={{
                  menuPortal,
                }}
              />
            </div>
          </Col>
          <Col style={{ minWidth: "100px" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label>Ship Qty</label>
              <Input
                type="number"
                value={shipQty}
                onChange={(e) => setShipQty(e.target.value)}
                placeholder="Ship Qty"
              />
            </div>
          </Col>
          <Col style={{ minWidth: "100px" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label>Mail Qty</label>
              <Input
                type="number"
                value={mailQty}
                onChange={(e) => setMailQty(e.target.value)}
                placeholder="Mail Qty"
              />
            </div>
          </Col>
          <Col style={{ minWidth: "100px" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label>Max/All</label>
              <Select
                options={maxAllOptions}
                value={selectMaxAll}
                onChange={setSelectMaxAll}
                placeholder="Max/All"
                menuPortalTarget={
                  typeof window !== "undefined" ? document.body : null
                }
                menuPosition="fixed"
                styles={{
                  menuPortal,
                }}
              />
            </div>
          </Col>
          <Col style={{ minWidth: "120px" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label>Comment</label>
              <Input
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder="Comment"
              />
            </div>
          </Col>
          <Col style={{ minWidth: "150px" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label>Product Category</label>
              <Input
                value={productCategory || ""}
                readOnly
                style={{
                  backgroundColor: "#fafafa",
                  cursor: "not-allowed",
                }}
              />
            </div>
          </Col>
          <Col style={{ minWidth: "100px" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label>Cost</label>
              <Input
                type="number"
                step="0.01"
                value={
                  cost !== null && cost !== undefined && cost !== ""
                    ? cost
                    : "0.00"
                }
                onChange={(e) => setCost(e.target.value)}
                placeholder="Cost"
              />
            </div>
          </Col>
          <Col
            style={{
              minWidth: "50px",
              display: "flex",
              alignItems: "flex-end",
            }}
          >
            <Button
              type="primary"
              block
              onClick={(e) => {
                e.preventDefault();
                handleSaveList();
              }}
            >
              +
            </Button>
          </Col>
        </Row>
      </div>
    </Card>
  );
};

export default FormLayout;
